export default __webpack_public_path__ + "static/media/e-nstitute-desktop-three.35f46b30.png";